import { Grid2 as Grid, Typography } from '@mui/material'

import { useCreatePlanContext } from 'contexts/CreatePlanContextProvider'
import PlanAllocationTables from './PlanAllocationTables'
import PlanTargets from './PlanTargets'
import WizardCompensationHeader from './WizardCompensationHeader'

function ComponentSelectionForm() {
  const { totalComponentsInPlanValue, mode } = useCreatePlanContext()

  const roundedTotal = Math.round((totalComponentsInPlanValue || 0) * 100) / 100
  const isValid = roundedTotal === 100

  return (
    <>
      <Grid container spacing={3} alignItems="center">
        <Grid size={{ xs: 12 }}>
          <WizardCompensationHeader />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="h5" fontWeight="bold" sx={{ mb: -1 }}>
            Targets
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <PlanTargets />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="h5" fontWeight="bold" sx={{ mb: -1 }}>
            Allocations
            {mode !== 'REVIEW' && (
              <>
                <span>{' \u2014 '}</span>
                <span style={{ color: isValid ? 'inherit' : 'red' }}>({roundedTotal.toFixed(2)}%)</span>
              </>
            )}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <PlanAllocationTables />
        </Grid>
      </Grid>
    </>
  )
}

export default ComponentSelectionForm
